import { render, staticRenderFns } from "./OtpConfigForm.vue?vue&type=template&id=0507ee2f&scoped=true"
import script from "./OtpConfigForm.vue?vue&type=script&lang=js"
export * from "./OtpConfigForm.vue?vue&type=script&lang=js"
import style0 from "./OtpConfigForm.vue?vue&type=style&index=0&id=0507ee2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0507ee2f",
  null
  
)

export default component.exports